import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=6cdae477&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=6cdae477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdae477",
  null
  
)

export default component.exports